module.exports = __webpack_public_path__ + "img/c_billable rate.884dc40e.svg";